import React, { useEffect, useState } from "react";

const API = "https://live-evo.com/api";

async function adminFetch(url, options = {}) {
  const response = await fetch(url, {
    ...options,
    headers: {
      ...(options.headers || {}),
      Authorization:
        `Bearer ${localStorage.getItem("evoAccessToken") || ""}`
    }
  });

  if (!response.ok) {
    let data = {};
    try {
      data = await response.json();
    } catch {}
    throw new Error(data.error || "Action administrateur refusée.");
  }

  return response;
}

function AdminStaffWebPage() {
  const [personalEmail, setPersonalEmail] = useState("");
  const [staffList, setStaffList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [creating, setCreating] = useState(false);
  const [actionLoadingId, setActionLoadingId] = useState(null);

  const loadStaff = async () => {
    try {
      setLoading(true);

      const res = await adminFetch(`${API}/admin/staff`);
      const data = await res.json();

      setStaffList(data.staff || []);
    } catch (err) {
      console.log("Erreur chargement staff:", err);
      alert("Impossible de charger les staff");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadStaff();
  }, []);

  const createStaff = async () => {
    const email = personalEmail.trim().toLowerCase();

    if (!email) {
      alert("Entre l’email perso du user");
      return;
    }

    try {
      setCreating(true);

      const res = await adminFetch(`${API}/auth/staff/create`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          personal_email: email
        })
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || "Erreur");
      }

      alert(
        `Staff créé\n\nAdresse staff à donner au user :\n${data.staff_email}`
      );

      setPersonalEmail("");
      loadStaff();
    } catch (err) {
      console.log("Erreur création staff:", err);
      alert("Impossible de créer le staff");
    } finally {
      setCreating(false);
    }
  };

  const changeRole = async (staffId, role) => {
    try {
      setActionLoadingId(staffId);

      await adminFetch(`${API}/admin/staff/${staffId}/role`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ role })
      });

      alert(`Rôle changé en ${role}`);
      loadStaff();
    } catch (err) {
      alert("Impossible de changer le rôle");
    } finally {
      setActionLoadingId(null);
    }
  };

  const disableStaff = async (staffId) => {
    const ok = window.confirm(
      "Désactiver ce staff ?"
    );

    if (!ok) return;

    try {
      setActionLoadingId(staffId);

      await adminFetch(`${API}/admin/staff/${staffId}/disable`, {
        method: "PUT"
      });

      alert("Staff désactivé");
      loadStaff();
    } catch (err) {
      alert("Impossible de désactiver");
    } finally {
      setActionLoadingId(null);
    }
  };

  const enableStaff = async (staffId) => {
    try {
      setActionLoadingId(staffId);

      await adminFetch(`${API}/admin/staff/${staffId}/enable`, {
        method: "PUT"
      });

      alert("Staff réactivé");
      loadStaff();
    } catch (err) {
      alert("Impossible de réactiver");
    } finally {
      setActionLoadingId(null);
    }
  };

  const deleteStaff = async (staffId) => {
    const ok = window.confirm(
      "Supprimer définitivement ce staff ?"
    );

    if (!ok) return;

    try {
      setActionLoadingId(staffId);

      await adminFetch(`${API}/admin/staff/${staffId}`, {
        method: "DELETE"
      });

      alert("Staff supprimé");
      loadStaff();
    } catch (err) {
      alert("Impossible de supprimer");
    } finally {
      setActionLoadingId(null);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#020b14",
        padding: 18,
        color: "#fff"
      }}
    >
      <div style={{ maxWidth: 1300, margin: "0 auto" }}>
        <h1
          style={{
            color: "#00f2ff",
            fontSize: 22,
            fontWeight: "bold",
            textAlign: "center",
            marginBottom: 18
          }}
        >
          🛡️ Gestion Staff
        </h1>

        <div
          style={{
            background: "#061827",
            padding: 16,
            borderRadius: 12,
            border: "1px solid #12344a",
            marginBottom: 20
          }}
        >
          <div
            style={{
              color: "#fff",
              fontWeight: "bold",
              marginBottom: 8
            }}
          >
            Email perso du user
          </div>

          <input
            type="email"
            placeholder="exemple@gmail.com"
            value={personalEmail}
            onChange={(e) =>
              setPersonalEmail(e.target.value)
            }
            style={{
              width: "100%",
              background: "#020b14",
              border: "1px solid #1a3d52",
              color: "#fff",
              borderRadius: 8,
              padding: 12,
              marginBottom: 12
            }}
          />

          <button
            onClick={createStaff}
            disabled={creating}
            style={{
              background: "#00f2ff",
              padding: 12,
              borderRadius: 8,
              border: "none",
              color: "#001018",
              fontWeight: "bold",
              width: "100%",
              cursor: "pointer"
            }}
          >
            {creating
              ? "Création..."
              : "Créer le compte staff"}
          </button>

          <div
            style={{
              color: "#8fa6ad",
              fontSize: 12,
              marginTop: 10
            }}
          >
            Le user garde son compte perso.
            Tu lui donnes seulement l’adresse staff générée.
          </div>
        </div>

        <div
          style={{
            color: "#fff",
            fontWeight: "bold",
            marginBottom: 12
          }}
        >
          Staff existants
        </div>

        {loading ? (
          <div
            style={{
              color: "#00f2ff",
              textAlign: "center",
              marginTop: 40
            }}
          >
            Chargement...
          </div>
        ) : staffList.length === 0 ? (
          <div
            style={{
              color: "#8fa6ad",
              textAlign: "center"
            }}
          >
            Aucun staff trouvé.
          </div>
        ) : (
          staffList.map((item) => {
            const isActive =
              item.active === 1 ||
              item.active === true;

            const isLoadingThis =
              actionLoadingId === item.id;

            return (
              <div
                key={item.id}
                style={{
                  background: "#051626",
                  padding: 14,
                  borderRadius: 10,
                  marginBottom: 12,
                  border: "1px solid #1a2b3c"
                }}
              >
                <div
                  style={{
                    color: "#00f2ff",
                    fontWeight: "bold",
                    marginBottom: 6
                  }}
                >
                  🛡️ {item.staff_email}
                </div>

                <div style={textStyle}>
                  Compte perso :
                  {" "}
                  {item.personal_email ||
                    "Non renseigné"}
                </div>

                <div style={textStyle}>
                  Rôle actuel :
                  {" "}
                  {item.role || "staff"}
                </div>

                <div
                  style={{
                    ...textStyle,
                    color: isActive
                      ? "#00ff88"
                      : "#ff4d4d"
                  }}
                >
                  Statut :
                  {" "}
                  {isActive
                    ? "Actif"
                    : "Désactivé"}
                </div>

                <div
                  style={{
                    marginTop: 14,
                    paddingTop: 10,
                    borderTop:
                      "1px solid #12344a"
                  }}
                >
                  <div
                    style={{
                      color: "#fff",
                      fontSize: 12,
                      fontWeight: "bold",
                      marginBottom: 8
                    }}
                  >
                    Changer le rôle :
                  </div>

                  <div
                    style={{
                      display: "flex",
                      gap: 8,
                      flexWrap: "wrap"
                    }}
                  >
                    <button
                      disabled={isLoadingThis}
                      onClick={() =>
                        changeRole(
                          item.id,
                          "staff"
                        )
                      }
                      style={{
                        ...roleBtn,
                        background:
                          item.role === "staff"
                            ? "#00f2ff"
                            : "#102235"
                      }}
                    >
                      Staff
                    </button>

                    <button
                      disabled={isLoadingThis}
                      onClick={() =>
                        changeRole(
                          item.id,
                          "moderateur"
                        )
                      }
                      style={{
                        ...roleBtn,
                        background:
                          item.role ===
                          "moderateur"
                            ? "#00f2ff"
                            : "#102235"
                      }}
                    >
                      Modérateur
                    </button>

                    <button
                      disabled={isLoadingThis}
                      onClick={() =>
                        changeRole(
                          item.id,
                          "admin"
                        )
                      }
                      style={{
                        ...roleBtn,
                        background:
                          item.role === "admin"
                            ? "#ff9500"
                            : "#102235"
                      }}
                    >
                      Admin
                    </button>
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    gap: 8,
                    marginTop: 14,
                    flexWrap: "wrap"
                  }}
                >
                  {isActive ? (
                    <button
                      disabled={isLoadingThis}
                      onClick={() =>
                        disableStaff(item.id)
                      }
                      style={{
                        ...actionBtn,
                        background: "#ff9500"
                      }}
                    >
                      {isLoadingThis
                        ? "Action..."
                        : "Désactiver"}
                    </button>
                  ) : (
                    <button
                      disabled={isLoadingThis}
                      onClick={() =>
                        enableStaff(item.id)
                      }
                      style={{
                        ...actionBtn,
                        background: "#00aa66"
                      }}
                    >
                      {isLoadingThis
                        ? "Action..."
                        : "Réactiver"}
                    </button>
                  )}

                  <button
                    disabled={isLoadingThis}
                    onClick={() =>
                      deleteStaff(item.id)
                    }
                    style={{
                      ...actionBtn,
                      background: "#ff2d55"
                    }}
                  >
                    Supprimer
                  </button>
                </div>
              </div>
            );
          })
        )}

        <button
          onClick={() => {
            window.location.href = "/admin";
          }}
          style={{
            background: "#007bff",
            padding: 12,
            borderRadius: 8,
            border: "none",
            color: "#fff",
            fontWeight: "bold",
            width: "100%",
            marginTop: 14,
            cursor: "pointer"
          }}
        >
          ← Retour Admin
        </button>
      </div>
    </div>
  );
}

const textStyle = {
  color: "#8fa6ad",
  fontSize: 12,
  marginBottom: 4
};

const roleBtn = {
  padding: "8px 12px",
  borderRadius: 8,
  border: "1px solid #1a3d52",
  color: "#fff",
  fontWeight: "bold",
  cursor: "pointer"
};

const actionBtn = {
  flex: 1,
  minWidth: 140,
  padding: 11,
  borderRadius: 8,
  border: "none",
  color: "#fff",
  fontWeight: "bold",
  cursor: "pointer"
};

export default AdminStaffWebPage;
